import React, { type ReactNode } from 'react';
import { GoalsContainer, GoalsErrorFlag } from '@atlassian/jira-portfolio-3-atlas-goals';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';

const GoalsWrapper = ({
	issueGoalARIs,
	children,
	isAtlasConnectInstalled,
}: {
	issueGoalARIs: string[];
	children: ReactNode;
	isAtlasConnectInstalled: boolean;
}) => {
	const cloudId = useCloudId();

	return (
		<GoalsContainer
			goalARIs={issueGoalARIs}
			cloudId={cloudId}
			isAtlasConnectInstalled={isAtlasConnectInstalled}
		>
			{children}
			<GoalsErrorFlag />
		</GoalsContainer>
	);
};

export default GoalsWrapper;
